// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   FaCalendarAlt,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";
// import PromptLoginCard from "../PromptLoginCard";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";
// import FilterOrderForm from "./FilterOrderForm";
// import heroImage from "../images/filter.png";
// import "./filterStyle.css";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
// import Loader from "../../../Components/LoaderSpin/Loader";

// const FilterService = () => {
//   const { t } = useTranslation();
//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false;
//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );
//   // Form fields
//   const [filterType, setFilterType] = useState("");
//   const [newFilterSetup, setNewFilterSetup] = useState(0);
//   const [installationFilter, setInstallationFilter] = useState(0);
//   const [uninstallationFilter, setUninstallationFilter] = useState(0);
//   const [kitReplacement, setKitReplacement] = useState(0);
//   const [pipeLeakOrReplace, setPipeLeakOrReplace] = useState(0);
//   const [fullServicing, setFullServicing] = useState(0);
//   const [checkUp, setCheckUp] = useState(false);
//   const [remarks, setRemarks] = useState("");
//   const [city, setCity] = useState("");
//   const [address, setAddress] = useState("");
//   // Rebook same servitor
//   const [useSameServitor, setUseSameServitor] = useState(false);
//   const [prevServitorName, setPrevServitorName] = useState("");
//   // Rating data
//   const [ratingData, setRatingData] = useState({
//     reviewCount: 0,
//     avgRating: 0,
//   });
//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(false);
//   // Date & time
//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date();
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };
//   const [selectedDate, setSelectedDate] = useState(getInitialDate());
//   // Populate fields for rebook
//   useEffect(() => {
//     if (rebookState) {
//       setFilterType(prevOrder.filter_type || "");
//       setNewFilterSetup(prevOrder.new_filter_setup || 0);
//       setInstallationFilter(prevOrder.installation_filter || 0);
//       setUninstallationFilter(prevOrder.uninstallation_filter || 0);
//       setKitReplacement(prevOrder.kit_replacement || 0);
//       setPipeLeakOrReplace(prevOrder.pipe_leak_or_replace || 0);
//       setFullServicing(prevOrder.full_servicing || 0);
//       setCheckUp(prevOrder.check_up || false);
//       setRemarks(prevOrder.remarks || "");
//       setCity(prevOrder.City || "");
//       setAddress(prevOrder.Address || "");
//     }
//   }, [rebookState, prevOrder]);
//   // Fetch user profile
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await axios.get(`${URL}/user/${userId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally { setLoading(false);}
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);
//   // Fetch servitor name for rebook
//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch((err) => console.error("Error fetching servitor:", err));
//     }
//   }, [rebookState, prevOrder.servitor_id]);

//   // Fetch filter ratings
//   // useEffect(() => {
//   //   axios
//   //     .get(`${URL}/api/ratings`)
//   //     .then(({ data }) => {
//   //       const filter = data["filter"] || {};
//   //       setRatingData({
//   //         reviewCount: filter.reviewCount || 0,
//   //         avgRating: filter.avgRating || 0,
//   //       });
//   //     })
//   //     .catch((err) => {console.error("Failed to load ratings:", err)});
//   // }, []);

//   useEffect(() => {
//       const loadRatings = async () => {
//         try {
//           setLoading(true);
//           const { data } = await axios.get(`${URL}/api/ratings`);
//           const { filter = {} } = data;
//           setRatingData({
//             reviewCount: filter.reviewCount || 0,
//             avgRating: filter.avgRating || 0,
//           });
//         } catch (err) {
//           console.error("Failed to load ratings:", err);
//         } finally {
//           setLoading(false);
//         }
//       };
//       loadRatings();
//     }, []);

//   // Render star ratings
//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };
//   // Generate time slots
//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split("T")[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";
//     let startHour = startTime;
//     let startMinute = 0;
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return [];
//       }
//       if (currentHour >= startTime) {
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }
//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };
//   // Calculate price
//   const calculatePrice = () => {
//     let price = 100;
//     price += newFilterSetup * 500;
//     price += installationFilter * 300;
//     price += uninstallationFilter * 200;
//     price += kitReplacement * 150;
//     price += pipeLeakOrReplace * 120;
//     price += fullServicing * 400;
//     if (checkUp) price += 100;
//     return price;
//   };
//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     const dateStr = selectedDate.toISOString().split("T")[0];
//     const time = e.target.time.value;
//     const formDetails = {
//       filterType,
//       new_filter_setup: newFilterSetup,
//       installation_filter: installationFilter,
//       uninstallation_filter: uninstallationFilter,
//       kit_replacement: kitReplacement,
//       pipe_leak_or_replace: pipeLeakOrReplace,
//       full_servicing: fullServicing,
//       check_up: checkUp,
//       remarks,
//       price: calculatePrice(),
//       date: dateStr,
//       time,
//       useSameServitor,
//       previousServitorId: useSameServitor ? prevOrder.servitor_id : undefined,
//       serviceId: 3, // Assuming Filter service ID is 3
//       City: city,
//       Address: address,
//     };
//     setFormData(formDetails);
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };
//   // Handle order submission
//   const handleOrderSubmit = () => {
//     setShowOrderForm(false);
//     // Reset form
//     setFilterType("");
//     setNewFilterSetup(0);
//     setInstallationFilter(0);
//     setUninstallationFilter(0);
//     setKitReplacement(0);
//     setPipeLeakOrReplace(0);
//     setFullServicing(0);
//     setCheckUp(false);
//     setRemarks("");
//     setUseSameServitor(false);
//     setFormData({});
//     setCity("");
//     setAddress("");
//   };
//   // PlusMinusInput component
//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const handleIncrement = () => {
//       if (value < max) setValue(value + 1);
//     };
//     const handleDecrement = () => {
//       if (value > min) setValue(value - 1);
//     };
//     return (
//       <div className="FilterService-plusMinusInput">
//         <button
//           type="button"
//           className="FilterService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="FilterService-valueDisplay">
//           {value} {t(value === 1 ? "filter.form.unit" : "filter.form.units")}
//         </span>
//         <button
//           type="button"
//           className="FilterService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };
//   // Helper to safely get array translations
//   const getTranslationArray = (key) => {
//     const result = t(key, { returnObjects: true });
//     return Array.isArray(result) ? result : [];
//   };
//   return (
//     <>
//       <div className="FilterService-container">
//         <Navbar />
//         <Loader show={loading} />
//         {/* Service Card */}
//         <div className="FilterService-card">
//           {/* Hero Section */}
//           <div className="FilterService-hero">
//             <img src={heroImage} alt={t("filter.hero_alt")} />
//           </div>
//           <div className="FilterService-header">
//             <h1>
//               {rebookState
//                 ? t("filter.header.rebook_title")
//                 : t("filter.header.title")}
//             </h1>
//             <div className="FilterService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="FilterService-reviews">
//               {ratingData.reviewCount.toLocaleString()}{" "}
//               {t("filter.reviewsLabel")}
//             </div>
//           </div>
//           {/* Categories / Info Blocks */}
//           <div className="FilterService-categories">
//             <div className="FilterService-category">
//               <h5>
//                 <span className="FilterService-categoryIcon">💧</span>
//                 {t("filter.categories.setup_services.title")}
//               </h5>
//               <p className="FilterService-serviceDescription">
//                 {t("filter.categories.setup_services.description")}
//               </p>
//             </div>
//             <div className="FilterService-category">
//               <h5>
//                 <span className="FilterService-categoryIcon">🛠️</span>
//                 {t("filter.categories.maintenance.title")}
//               </h5>
//               <p className="FilterService-serviceDescription">
//                 {t("filter.categories.maintenance.description")}
//               </p>
//             </div>
//             <div className="FilterService-category">
//               <h5>
//                 <span className="FilterService-categoryIcon">🔍</span>
//                 {t("filter.categories.safety_check.title")}
//               </h5>
//               <p className="FilterService-serviceDescription">
//                 {t("filter.categories.safety_check.description")}
//               </p>
//             </div>
//           </div>
//           {/* The Service Form */}
//           <form onSubmit={handleGetService} className="FilterService-form">
//             {/* Filter Type */}
//             <h3 className="FilterService-sectionTitle">
//               <i className="fas fa-filter"></i>
//               {t("filter.form.filter_type_title")}
//             </h3>
//             <div className="FilterService-serviceOptions">
//               <div className="FilterService-optionGroup FilterService-fullWidth">
//                 {/* <label htmlFor="filterType">
//                   {t("filter.form.labels.filterType")}
//                 </label> */}
//                 <label htmlFor="filterType" className="tooltip-label">
//                                   {t("filter.form.labels.filterType")}
//                                   <ServiceTooltip
//                                     title={t("filter.tooltips.filterType.title")}
//                                     description={t("filter.tooltips.filterType.description")}
//                                   />
//                                 </label>
//                 <select
//                   id="filterType"
//                   value={filterType}
//                   onChange={(e) => setFilterType(e.target.value)}
//                   required
//                 >
//                   <option value="">
//                     {t("filter.form.placeholders.select")}
//                   </option>
//                   <option value="RO">RO</option>
//                   <option value="UV">UV</option>
//                   <option value="UF">UF</option>
//                   <option value="RO+UV">RO+UV</option>
//                   <option value="Under-sink">Under-sink</option>
//                   <option value="Countertop">Countertop</option>
//                   <option value="Others">Others</option>
//                 </select>
//               </div>
//             </div>
//             {/* Setup Services */}
//             <h3 className="FilterService-sectionTitle">
//               <i className="fas fa-tools"></i>
//               {t("filter.form.setup_services_title")}
//             </h3>
//             <div className="FilterService-serviceOptions">
//               <div className="FilterService-optionGroup">
//                 {/* <label htmlFor="newFilterSetup">
//                   {t("filter.form.labels.newSetup")}
//                 </label> */}
//                 <label htmlFor="newFilterSetup" className="tooltip-label">
//                                   {t("filter.form.labels.newSetup")}
//                                   <ServiceTooltip
//                                     title={t("filter.tooltips.newSetup.title")}
//                                     description={t("filter.tooltips.newSetup.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="newFilterSetup"
//                   value={newFilterSetup}
//                   setValue={setNewFilterSetup}
//                 />
//               </div>
//               <div className="FilterService-optionGroup">
//                 {/* <label htmlFor="installationFilter">
//                   {t("filter.form.labels.filterSetup")}
//                 </label> */}
//                 <label htmlFor="installationFilter" className="tooltip-label">
//                                   {t("filter.form.labels.filterSetup")}
//                                   <ServiceTooltip
//                                     title={t("filter.tooltips.filterSetup.title")}
//                                     description={t("filter.tooltips.filterSetup.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="installationFilter"
//                   value={installationFilter}
//                   setValue={setInstallationFilter}
//                 />
//               </div>
//               <div className="FilterService-optionGroup">
//                 {/* <label htmlFor="uninstallationFilter">
//                   {t("filter.form.labels.uninstallationFilter")}
//                 </label> */}
//                 <label htmlFor="uninstallationFilter" className="tooltip-label">
//                                   {t("filter.form.labels.uninstallationFilter")}
//                                   <ServiceTooltip
//                                     title={t("filter.tooltips.uninstallationFilter.title")}
//                                     description={t("filter.tooltips.uninstallationFilter.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="uninstallationFilter"
//                   value={uninstallationFilter}
//                   setValue={setUninstallationFilter}
//                 />
//               </div>
//             </div>
//             {/* Maintenance Services */}
//             <h3 className="FilterService-sectionTitle">
//               <i className="fas fa-cogs"></i>
//               {t("filter.form.maintenance_services_title")}
//             </h3>
//             <div className="FilterService-serviceOptions">
//               <div className="FilterService-optionGroup">
//                 {/* <label htmlFor="kitReplacement">
//                   {t("filter.form.labels.kitReplacement")}
//                 </label> */}
//                 <label htmlFor="kitReplacement" className="tooltip-label">
//                                   {t("filter.form.labels.kitReplacement")}
//                                   <ServiceTooltip
//                                     title={t("filter.tooltips.kitReplacement.title")}
//                                     description={t("filter.tooltips.kitReplacement.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="kitReplacement"
//                   value={kitReplacement}
//                   setValue={setKitReplacement}
//                 />
//               </div>
//               <div className="FilterService-optionGroup">
//                 {/* <label htmlFor="pipeLeakOrReplace">
//                   {t("filter.form.labels.pipeLeakOrReplace")}
//                 </label> */}
//                 <label htmlFor="pipeLeakOrReplace" className="tooltip-label">
//                                   {t("filter.form.labels.pipeLeakOrReplace")}
//                                   <ServiceTooltip
//                                     title={t("filter.tooltips.pipeLeakOrReplace.title")}
//                                     description={t("filter.tooltips.pipeLeakOrReplace.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="pipeLeakOrReplace"
//                   value={pipeLeakOrReplace}
//                   setValue={setPipeLeakOrReplace}
//                 />
//               </div>
//               <div className="FilterService-optionGroup">
//                 {/* <label htmlFor="fullServicing">
//                   {t("filter.form.labels.fullServicing")}
//                 </label> */}
//                 <label htmlFor="fullServicing" className="tooltip-label">
//                                   {t("filter.form.labels.fullServicing")}
//                                   <ServiceTooltip
//                                     title={t("filter.tooltips.fullServicing.title")}
//                                     description={t("filter.tooltips.fullServicing.description")}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="fullServicing"
//                   value={fullServicing}
//                   setValue={setFullServicing}
//                 />
//               </div>
//               <div className="FilterService-optionGroup">
//                 {/* <label htmlFor="checkUp">
//                   {t("filter.form.labels.checkUp")}
//                 </label> */}
//                 <label htmlFor="checkUp" className="tooltip-label">
//                                   {t("filter.form.labels.checkUp")}
//                                   <ServiceTooltip
//                                     title={t("filter.tooltips.checkUp.title")}
//                                     description={t("filter.tooltips.checkUp.description")}
//                                   />
//                                 </label>
//                 <select
//                   id="checkUp"
//                   value={checkUp ? "yes" : "no"}
//                   onChange={(e) => setCheckUp(e.target.value === "yes")}
//                 >
//                   <option value="no">
//                     {t("filter.form.labels.checkUp_options.no")}
//                   </option>
//                   <option value="yes">
//                     {t("filter.form.labels.checkUp_options.yes")}
//                   </option>
//                 </select>
//               </div>
//             </div>
       
//             {/* Rebook Same Servitor */}
//             {rebookState && prevServitorName && (
//               <div className="FilterService-rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                   <span className="rebook-text">
//                     {t("filter.form.rebook_same_servitor_prefix")}
//                     <span className="strong-name">{prevServitorName}</span>
//                     {t("filter.form.rebook_same_servitor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}
//             {/* Price Display */}
//             <div className="FilterService-priceDisplay">
//               <span>
//                 {t("filter.form.price_display", { price: calculatePrice() })}
//               </span>
//               {/* <small>{t("filter.form.price_note")}</small> */}
//             </div>

//             {/* Pricing note banner */}
//             <div className="FilterService-priceNote" role="note" aria-live="polite">
//               <div className="FilterService-priceNote-icon" aria-hidden="true">
//                 {/* small star icon (inline SVG) */}
//                 <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
//                   <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
//                 </svg>
//               </div>
//               <div className="FilterService-priceNote-content">
//                 <div className="FilterService-priceNote-title">
//                   {t("filter.price_note.title")}
//                 </div>
//                 <p className="FilterService-priceNote-text">
//                   <strong>{t("filter.price_note.service_charges_only_label")}</strong>{" "}
//                   {t("filter.price_note.body")}
//                 </p>
//               </div>
//             </div>


//             {/* Booking Details */}
//             <div className="FilterService-bookingDetails">
//               <div className="FilterService-optionGroup">
//                 <label htmlFor="date">{t("filter.form.labels.date")}</label>
//                 <div className="FilterService-dateInputWrapper">
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()}
//                     placeholderText={t("filter.form.labels.date")}
//                     className="FilterService-dateInput"
//                   />
//                   <FaCalendarAlt
//                     className="FilterService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(".FilterService-dateInput")
//                         .focus()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="FilterService-optionGroup">
//                 <label htmlFor="time">{t("filter.form.labels.time")}</label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//             {/* Remarks */}
//             <div className="FilterService-serviceOptions">
//               <div className="FilterService-optionGroup FilterService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("filter.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("filter.form.placeholders.remarks")}
//                   className="FilterService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>
//             <button type="submit" className="FilterService-actionBtn">
//               {rebookState
//                 ? t("filter.form.rebook_button")
//                 : t("filter.form.book_button")}
//             </button>
//           </form>
//           {/* Info Box */}
//           <div className="FilterService-infoBox">
//             <h4>{t("filter.info_box.title")}</h4>
//             <p>{t("filter.info_box.description")}</p>
//           </div>
//           {/* Additional Info Section */}
//           <div className="FilterService-additionalInfo">
//             <div className="FilterService-sectionCard">
//               <h2 className="FilterService-sectionTitle">
//                 {t("filter.additional_info.how_to_place_order.title")}
//               </h2>
//               <ol className="FilterService-stepList">
//                 {getTranslationArray(
//                   "filter.additional_info.how_to_place_order.steps"
//                 ).map((step, idx) => (
//                   <li key={idx}>{step}</li>
//                 ))}
//               </ol>
//             </div>
//             <div className="FilterService-row2col">
//               <div className="FilterService-sectionCard FilterService-gradientBg2">
//                 <h2 className="FilterService-sectionTitle">
//                   {t("filter.additional_info.why_choose_HelpNao.title")}
//                 </h2>
//                 <p className="FilterService-sectionText">
//                   {t("filter.additional_info.why_choose_HelpNao.description")}
//                 </p>
//                 <div className="FilterService-featureGrid">
//                   {getTranslationArray(
//                     "filter.additional_info.why_choose_HelpNao.features"
//                   ).map((feature, idx) => (
//                     <div key={idx} className="FilterService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "balance-scale"
//                             : idx === 1
//                             ? "user-shield"
//                             : idx === 2
//                             ? "mobile-alt"
//                             : "headset"
//                         } FilterService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="FilterService-sectionCard FilterService-gradientBg">
//                 <h2 className="FilterService-sectionTitle">
//                   {t("filter.additional_info.key_features.title")}
//                 </h2>
//                 <div className="FilterService-featureGrid">
//                   {getTranslationArray(
//                     "filter.additional_info.key_features.features"
//                   ).map((feature, idx) => (
//                     <div key={idx} className="FilterService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           idx === 0
//                             ? "clock"
//                             : idx === 1
//                             ? "shield-alt"
//                             : idx === 2
//                             ? "check-circle"
//                             : idx === 3
//                             ? "shield-alt"
//                             : "credit-card"
//                         } FilterService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div className="FilterService-sectionCard">
//               <h2 className="FilterService-sectionTitle">
//                 {t("filter.additional_info.service_details.title")}
//               </h2>
//               <div className="FilterService-serviceGrid">
//                 {getTranslationArray(
//                   "filter.additional_info.service_details.items"
//                 ).map((item, idx) => (
//                   <div key={idx} className="FilterService-serviceItem">
//                     <i
//                       className={`fas fa-${
//                         idx === 0 ? "filter" : "tools"
//                       } FilterService-serviceIcon`}
//                       aria-hidden="true"
//                     ></i>
//                     <div>
//                       <h3>{item.title}</h3>
//                       <p>{item.description}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="FilterService-sectionCard FilterService-gradientBg3">
//               <h2 className="FilterService-sectionTitle">
//                 {t("filter.additional_info.order_tracking.title")}
//               </h2>
//               <div className="FilterService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="FilterService-sectionText FilterService-centerText">
//                 {t("filter.additional_info.order_tracking.description")}
//               </p>
//             </div>
//           </div>
//         </div>
//         {/* Modals */}
//         {showOrderForm && (
//           <FilterOrderForm
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit}
//             formData={formData}
//             user={user}
//             previousServitorName={prevServitorName}
//           />
//         )}
//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>
//       {/* Feedback Section */}
//       {ratingData.reviewCount > 0 && (
//       <div className="FilterService-feedback-section">
//         <FeedbackPage serviceType="Filter" />
//       </div>
//       )}
//       <Footer />
//     </>
//   );
// };
// export default FilterService;










// ***** Update with pricing (25-Oct-2025) ***** //
import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  FaCalendarAlt,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
} from "react-icons/fa";
import Select from "react-select";
import PromptLoginCard from "../PromptLoginCard";
import FeedbackPage from "../../Feedback/FeedbackPage";
import Footer from "../../../Components/Footer/Footer";
import FilterOrderForm from "./FilterOrderForm";
import heroImage from "../images/filter.png";
import "./filterStyle.css";
import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
import Loader from "../../../Components/LoaderSpin/Loader";
import { FILTER_PRICING } from "../servicePricing";

const P = FILTER_PRICING;
const BASE_FEE = Number(P?.base ?? 0);
const CHECKUP_FEE = Number(P?.checkupFlat ?? 0);

const FilterService = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const rebookState = location.state?.fromRebook || false;
  const prevOrder = useMemo(
    () => location.state?.previousOrder || {},
    [location.state?.previousOrder]
  );
  // Form fields
  const [filterType, setFilterType] = useState("");
  const [newFilterSetup, setNewFilterSetup] = useState(0);
  const [installationFilter, setInstallationFilter] = useState(0);
  const [uninstallationFilter, setUninstallationFilter] = useState(0);
  const [kitReplacement, setKitReplacement] = useState(0);
  const [pipeLeakOrReplace, setPipeLeakOrReplace] = useState(0);
  const [fullServicing, setFullServicing] = useState(0);
  const [checkUp, setCheckUp] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  // Rebook same servitor
  const [useSameServitor, setUseSameServitor] = useState(false);
  const [prevServitorName, setPrevServitorName] = useState("");
  // Rating data
  const [ratingData, setRatingData] = useState({
    reviewCount: 0,
    avgRating: 0,
  });
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  // Date & time
  const getInitialDate = () => {
    const now = new Date();
    const currentHour = now.getHours();
    if (currentHour < 7 || currentHour >= 21) {
      const tomorrow = new Date();
      tomorrow.setDate(now.getDate() + 1);
      return tomorrow;
    }
    return now;
  };
  const [selectedDate, setSelectedDate] = useState(getInitialDate());
  // Populate fields for rebook
  useEffect(() => {
    if (rebookState) {
      setFilterType(prevOrder.filter_type || "");
      setNewFilterSetup(prevOrder.new_filter_setup || 0);
      setInstallationFilter(prevOrder.installation_filter || 0);
      setUninstallationFilter(prevOrder.uninstallation_filter || 0);
      setKitReplacement(prevOrder.kit_replacement || 0);
      setPipeLeakOrReplace(prevOrder.pipe_leak_or_replace || 0);
      setFullServicing(prevOrder.full_servicing || 0);
      setCheckUp(prevOrder.check_up || false);
      setRemarks(prevOrder.remarks || "");
      setCity(prevOrder.City || "");
      setAddress(prevOrder.Address || "");
    }
  }, [rebookState, prevOrder]);
  // Fetch user profile
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken = jwtDecode(token);
          const userId = decodedToken.Id.startsWith("user-")
            ? decodedToken.Id.split("user-")[1]
            : decodedToken.Id;
          const response = await axios.get(`${URL}/user/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(response.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally { setLoading(false);}
    };
    fetchUserData();
    window.scrollTo(0, 0);
  }, []);
  // Fetch servitor name for rebook
  useEffect(() => {
    if (rebookState && prevOrder.servitor_id) {
      axios
        .get(`${URL}/servitors/${prevOrder.servitor_id}`)
        .then((res) => {
          const s = res.data;
          setPrevServitorName(`${s.FirstName} ${s.LastName}`);
        })
        .catch((err) => console.error("Error fetching servitor:", err));
    }
  }, [rebookState, prevOrder.servitor_id]);

  // Fetch filter ratings
  // useEffect(() => {
  //   axios
  //     .get(`${URL}/api/ratings`)
  //     .then(({ data }) => {
  //       const filter = data["filter"] || {};
  //       setRatingData({
  //         reviewCount: filter.reviewCount || 0,
  //         avgRating: filter.avgRating || 0,
  //       });
  //     })
  //     .catch((err) => {console.error("Failed to load ratings:", err)});
  // }, []);

  useEffect(() => {
      const loadRatings = async () => {
        try {
          setLoading(true);
          const { data } = await axios.get(`${URL}/api/ratings`);
          const { filter = {} } = data;
          setRatingData({
            reviewCount: filter.reviewCount || 0,
            avgRating: filter.avgRating || 0,
          });
        } catch (err) {
          console.error("Failed to load ratings:", err);
        } finally {
          setLoading(false);
        }
      };
      loadRatings();
    }, []);

  // Render star ratings
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} />);
      } else {
        stars.push(<FaRegStar key={i} />);
      }
    }
    return stars;
  };
  // Generate time slots
  const generateTimeSlots = (dateObj) => {
    const startTime = 7;
    const endTime = 21;
    const slots = [];
    const now = new Date();
    const todayStr = now.toISOString().split("T")[0];
    const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";
    let startHour = startTime;
    let startMinute = 0;
    if (selectedDateStr === todayStr) {
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      if (currentHour >= endTime) {
        return [];
      }
      if (currentHour >= startTime) {
        if (currentMinute > 0 && currentMinute <= 30) {
          startHour = currentHour;
          startMinute = 30;
        } else if (currentMinute > 30) {
          startHour = currentHour + 1;
          startMinute = 0;
        } else {
          startHour = currentHour;
          startMinute = 0;
        }
      }
    }
    for (let hour = startHour; hour <= endTime; hour++) {
      const minuteStart = hour === startHour ? startMinute : 0;
      for (let minute = minuteStart; minute < 60; minute += 30) {
        if (selectedDateStr === todayStr) {
          const slotTime = new Date(now);
          slotTime.setHours(hour, minute, 0, 0);
          if (slotTime <= now) continue;
        }
        const displayHour = hour > 12 ? hour - 12 : hour;
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedTime = `${displayHour}:${String(minute).padStart(
          2,
          "0"
        )} ${ampm}`;
        slots.push(formattedTime);
      }
    }
    return slots;
  };
  // Calculate price
  // const calculatePrice = () => {
  //   let price = 100;
  //   price += newFilterSetup * 500;
  //   price += installationFilter * 300;
  //   price += uninstallationFilter * 200;
  //   price += kitReplacement * 150;
  //   price += pipeLeakOrReplace * 120;
  //   price += fullServicing * 400;
  //   if (checkUp) price += 100;
  //   return price;
  // };

  // ===== Pricing helpers (from FILTER_PRICING) =====
    const U = (v) => Math.max(0, Number(v) || 0);
    const unit = (key) => Number(P?.perUnit?.[key] ?? 0);
    const fmtTk = (n) => `${(Number(n) || 0).toLocaleString()} tk`;
  
    // don’t show totals until something is selected
    const hasAnySelection = useMemo(() => {
      const counts = [
        newFilterSetup,
        installationFilter,
        uninstallationFilter,
        kitReplacement,
        pipeLeakOrReplace,
        fullServicing,
      ];
      return counts.some((c) => U(c) > 0) || !!checkUp;
    }, [
      newFilterSetup,
      installationFilter,
      uninstallationFilter,
      kitReplacement,
      pipeLeakOrReplace,
      fullServicing,
      checkUp,
    ]);
  
    const calculatePrice = () => {
      let price = 0;
  
      if (hasAnySelection) price += BASE_FEE;
  
      price += U(newFilterSetup) * unit("newFilterSetup");
      price += U(installationFilter) * unit("installationFilter");
      price += U(uninstallationFilter) * unit("uninstallationFilter");
      price += U(kitReplacement) * unit("kitReplacement");
      price += U(pipeLeakOrReplace) * unit("pipeLeakOrReplace");
      price += U(fullServicing) * unit("fullServicing");
  
      if (checkUp) price += CHECKUP_FEE;
  
      return Math.round(price);
    };
  
    // Build breakdown rows for UI
    const breakdownRows = useMemo(() => {
      const rows = [];
      const add = (label, count, key) => {
        const c = U(count);
        if (!c) return;
        const each = unit(key);
        rows.push({
          label,
          calc: `${c} × ${fmtTk(each)} =`,
          total: fmtTk(c * each),
        });
      };
  
      add(t("filter.breakdown.new_filter_setup", "New Filter Setup"), newFilterSetup, "newFilterSetup");
      add(t("filter.breakdown.installation_filter", "Filter Installation"), installationFilter, "installationFilter");
      add(t("filter.breakdown.uninstallation_filter", "Filter Uninstallation"), uninstallationFilter, "uninstallationFilter");
      add(t("filter.breakdown.kit_replacement", "Kit Replacement"), kitReplacement, "kitReplacement");
      add(t("filter.breakdown.pipe_leak_or_replace", "Pipe Leak/Replace"), pipeLeakOrReplace, "pipeLeakOrReplace");
      add(t("filter.breakdown.full_servicing", "Full Servicing"), fullServicing, "fullServicing");
  
      if (checkUp) {
        rows.push({
          label: t("filter.breakdown.checkup", "Checkup"),
          calc: "",
          total: fmtTk(CHECKUP_FEE),
        });
      }
  
      if (rows.length > 0 && BASE_FEE > 0) {
        rows.push({
          // label: t("filter.breakdown.booking_fee", "Booking Fee"),
          label: t("filter.breakdown.platform_support_fee", "Platform & Support Fee"),
          calc: "",
          total: fmtTk(BASE_FEE),
        });
      }
  
      return rows;
    }, [
      t,
      newFilterSetup,
      installationFilter,
      uninstallationFilter,
      kitReplacement,
      pipeLeakOrReplace,
      fullServicing,
      checkUp,
    ]);



   const FILTER_TYPE_OPTIONS = [
    { value: "RO", label: "RO" },
    { value: "UV", label: "UV" },
    { value: "UF", label: "UF" },
    { value: "RO+UV", label: "RO+UV" },
    { value: "Under-sink", label: "Under-sink" },
    { value: "Countertop", label: "Countertop" },
    { value: "Others", label: "Others" },
  ];

  

  // Handle form submission
  const handleGetService = (e) => {
    e.preventDefault();
    const dateStr = selectedDate.toISOString().split("T")[0];
    const time = e.target.time.value;
    const formDetails = {
      filterType,
      new_filter_setup: newFilterSetup,
      installation_filter: installationFilter,
      uninstallation_filter: uninstallationFilter,
      kit_replacement: kitReplacement,
      pipe_leak_or_replace: pipeLeakOrReplace,
      full_servicing: fullServicing,
      check_up: checkUp,
      remarks,
      price: calculatePrice(),
      date: dateStr,
      time,
      useSameServitor,
      previousServitorId: useSameServitor ? prevOrder.servitor_id : undefined,
      serviceId: 6, // Assuming Filter service ID is 3
      City: city,
      Address: address,
    };
    setFormData(formDetails);
    if (user) {
      setShowOrderForm(true);
    } else {
      setShowLoginPrompt(true);
    }
  };
  // Handle order submission
  const handleOrderSubmit = () => {
    setShowOrderForm(false);
    // Reset form
    setFilterType("");
    setNewFilterSetup(0);
    setInstallationFilter(0);
    setUninstallationFilter(0);
    setKitReplacement(0);
    setPipeLeakOrReplace(0);
    setFullServicing(0);
    setCheckUp(false);
    setRemarks("");
    setUseSameServitor(false);
    setFormData({});
    setCity("");
    setAddress("");
  };
  // PlusMinusInput component
  const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
    const handleIncrement = () => {
      if (value < max) setValue(value + 1);
    };
    const handleDecrement = () => {
      if (value > min) setValue(value - 1);
    };
    return (
      <div className="FilterService-plusMinusInput">
        <button
          type="button"
          className="FilterService-minusBtn"
          onClick={handleDecrement}
          disabled={value <= min}
        >
          −
        </button>
        <span className="FilterService-valueDisplay">
          {value} {t(value === 1 ? "filter.form.unit" : "filter.form.units")}
        </span>
        <button
          type="button"
          className="FilterService-plusBtn"
          onClick={handleIncrement}
          disabled={value >= max}
        >
          +
        </button>
      </div>
    );
  };
  // Helper to safely get array translations
  const getTranslationArray = (key) => {
    const result = t(key, { returnObjects: true });
    return Array.isArray(result) ? result : [];
  };
  return (
    <>
      <div className="FilterService-container">
        <Navbar />
        <Loader show={loading} />
        {/* Service Card */}
        <div className="FilterService-card">
          {/* Hero Section */}
          <div className="FilterService-hero">
            <img src={heroImage} alt={t("filter.hero_alt")} />
          </div>
          <div className="FilterService-header">
            <h1>
              {rebookState
                ? t("filter.header.rebook_title")
                : t("filter.header.title")}
            </h1>
            <div className="FilterService-rating">
              {renderStars(ratingData.avgRating)}
            </div>
            <div className="FilterService-reviews">
              {ratingData.reviewCount.toLocaleString()}{" "}
              {t("filter.reviewsLabel")}
            </div>
          </div>
          {/* Categories / Info Blocks */}
          {/* <div className="FilterService-categories">
            <div className="FilterService-category">
              <h5>
                <span className="FilterService-categoryIcon">💧</span>
                {t("filter.categories.setup_services.title")}
              </h5>
              <p className="FilterService-serviceDescription">
                {t("filter.categories.setup_services.description")}
              </p>
            </div>
            <div className="FilterService-category">
              <h5>
                <span className="FilterService-categoryIcon">🛠️</span>
                {t("filter.categories.maintenance.title")}
              </h5>
              <p className="FilterService-serviceDescription">
                {t("filter.categories.maintenance.description")}
              </p>
            </div>
            <div className="FilterService-category">
              <h5>
                <span className="FilterService-categoryIcon">🔍</span>
                {t("filter.categories.safety_check.title")}
              </h5>
              <p className="FilterService-serviceDescription">
                {t("filter.categories.safety_check.description")}
              </p>
            </div>
          </div> */}
          {/* The Service Form */}
          <form onSubmit={handleGetService} className="FilterService-form">
            {/* Filter Type */}
            <h3 className="FilterService-sectionTitle">
              <i className="fas fa-filter"></i>
              {t("filter.form.filter_type_title")}
            </h3>
            <div className="FilterService-serviceOptions">
              <div className="FilterService-optionGroup FilterService-fullWidth">
                {/* <label htmlFor="filterType">
                  {t("filter.form.labels.filterType")}
                </label> */}
                <label htmlFor="filterType" className="tooltip-label">
                                  {t("filter.form.labels.filterType")}
                                  <ServiceTooltip
                                    title={t("filter.tooltips.filterType.title")}
                                    description={t("filter.tooltips.filterType.description")}
                                  />
                                </label>
                {/* <select
                  id="filterType"
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  required
                >
                  <option value="">
                    {t("filter.form.placeholders.select")}
                  </option>
                  <option value="RO">RO</option>
                  <option value="UV">UV</option>
                  <option value="UF">UF</option>
                  <option value="RO+UV">RO+UV</option>
                  <option value="Under-sink">Under-sink</option>
                  <option value="Countertop">Countertop</option>
                  <option value="Others">Others</option>
                </select> */}


                <Select
                    inputId="filterType"
                    isMulti
                    options={FILTER_TYPE_OPTIONS}
                    placeholder={t("filter.form.placeholders.select")}
                    classNamePrefix="rs"
                    value={(filterType || "")
                      .split(",")
                      .map(s => s.trim())
                      .filter(Boolean)
                      .map(v => ({ value: v, label: v }))}
                    onChange={(vals) => {
                      const str = (vals || []).map(v => v.value).join(", ");
                      setFilterType(str);
                    }}
                  />
                  {/* <div className="form-text">
                    {filterType ? filterType : t("filter.form.placeholders.select")}
                  </div> */}
              </div>
            </div>
            {/* Setup Services */}
            <h3 className="FilterService-sectionTitle">
              <i className="fas fa-tools"></i>
              {t("filter.form.setup_services_title")}
            </h3>
            <div className="FilterService-serviceOptions">
              <div className="FilterService-optionGroup">
                {/* <label htmlFor="newFilterSetup">
                  {t("filter.form.labels.newSetup")}
                </label> */}
                <label htmlFor="newFilterSetup" className="tooltip-label">
                                  {t("filter.form.labels.newSetup")}
                                  <ServiceTooltip
                                    title={t("filter.tooltips.newSetup.title")}
                                    description={t("filter.tooltips.newSetup.description")}
                                  />
                                </label>
                <PlusMinusInput
                  id="newFilterSetup"
                  value={newFilterSetup}
                  setValue={setNewFilterSetup}
                />
              </div>
              <div className="FilterService-optionGroup">
                {/* <label htmlFor="installationFilter">
                  {t("filter.form.labels.filterSetup")}
                </label> */}
                <label htmlFor="installationFilter" className="tooltip-label">
                                  {t("filter.form.labels.filterSetup")}
                                  <ServiceTooltip
                                    title={t("filter.tooltips.filterSetup.title")}
                                    description={t("filter.tooltips.filterSetup.description")}
                                  />
                                </label>
                <PlusMinusInput
                  id="installationFilter"
                  value={installationFilter}
                  setValue={setInstallationFilter}
                />
              </div>
              <div className="FilterService-optionGroup">
                {/* <label htmlFor="uninstallationFilter">
                  {t("filter.form.labels.uninstallationFilter")}
                </label> */}
                <label htmlFor="uninstallationFilter" className="tooltip-label">
                                  {t("filter.form.labels.uninstallationFilter")}
                                  <ServiceTooltip
                                    title={t("filter.tooltips.uninstallationFilter.title")}
                                    description={t("filter.tooltips.uninstallationFilter.description")}
                                  />
                                </label>
                <PlusMinusInput
                  id="uninstallationFilter"
                  value={uninstallationFilter}
                  setValue={setUninstallationFilter}
                />
              </div>
            </div>
            {/* Maintenance Services */}
            <h3 className="FilterService-sectionTitle">
              <i className="fas fa-cogs"></i>
              {t("filter.form.maintenance_services_title")}
            </h3>
            <div className="FilterService-serviceOptions">
              <div className="FilterService-optionGroup">
                {/* <label htmlFor="kitReplacement">
                  {t("filter.form.labels.kitReplacement")}
                </label> */}
                <label htmlFor="kitReplacement" className="tooltip-label">
                                  {t("filter.form.labels.kitReplacement")}
                                  <ServiceTooltip
                                    title={t("filter.tooltips.kitReplacement.title")}
                                    description={t("filter.tooltips.kitReplacement.description")}
                                  />
                                </label>
                <PlusMinusInput
                  id="kitReplacement"
                  value={kitReplacement}
                  setValue={setKitReplacement}
                />
              </div>
              <div className="FilterService-optionGroup">
                {/* <label htmlFor="pipeLeakOrReplace">
                  {t("filter.form.labels.pipeLeakOrReplace")}
                </label> */}
                <label htmlFor="pipeLeakOrReplace" className="tooltip-label">
                                  {t("filter.form.labels.pipeLeakOrReplace")}
                                  <ServiceTooltip
                                    title={t("filter.tooltips.pipeLeakOrReplace.title")}
                                    description={t("filter.tooltips.pipeLeakOrReplace.description")}
                                  />
                                </label>
                <PlusMinusInput
                  id="pipeLeakOrReplace"
                  value={pipeLeakOrReplace}
                  setValue={setPipeLeakOrReplace}
                />
              </div>
              <div className="FilterService-optionGroup">
                {/* <label htmlFor="fullServicing">
                  {t("filter.form.labels.fullServicing")}
                </label> */}
                <label htmlFor="fullServicing" className="tooltip-label">
                                  {t("filter.form.labels.fullServicing")}
                                  <ServiceTooltip
                                    title={t("filter.tooltips.fullServicing.title")}
                                    description={t("filter.tooltips.fullServicing.description")}
                                  />
                                </label>
                <PlusMinusInput
                  id="fullServicing"
                  value={fullServicing}
                  setValue={setFullServicing}
                />
              </div>
              <div className="FilterService-optionGroup">
                {/* <label htmlFor="checkUp">
                  {t("filter.form.labels.checkUp")}
                </label> */}
                <label htmlFor="checkUp" className="tooltip-label">
                                  {t("filter.form.labels.checkUp")}
                                  <ServiceTooltip
                                    title={t("filter.tooltips.checkUp.title")}
                                    description={t("filter.tooltips.checkUp.description")}
                                  />
                                </label>
                <select
                  id="checkUp"
                  value={checkUp ? "yes" : "no"}
                  onChange={(e) => setCheckUp(e.target.value === "yes")}
                >
                  <option value="no">
                    {t("filter.form.labels.checkUp_options.no")}
                  </option>
                  <option value="yes">
                    {t("filter.form.labels.checkUp_options.yes")}
                  </option>
                </select>
              </div>
            </div>
       
            {/* Rebook Same Servitor */}
            {rebookState && prevServitorName && (
              <div className="FilterService-rebook-same-servitor">
                <label>
                  <input
                    type="checkbox"
                    checked={useSameServitor}
                    onChange={() => setUseSameServitor(!useSameServitor)}
                  />
                  <span className="rebook-text">
                    {t("filter.form.rebook_same_servitor_prefix")}
                    <span className="strong-name">{prevServitorName}</span>
                    {t("filter.form.rebook_same_servitor_suffix")}
                  </span>
                </label>
              </div>
            )}


            {/* ---------- Price Breakdown Card (only when selected) ---------- */}
            {breakdownRows.length > 0 && (
              <div className="FilterService-breakdownCard" aria-live="polite">
                <div className="FilterService-breakdownHeader">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v4h10V6H7zm0 6v6h10v-6H7zm2 1h2v2H9v-2zm0 3h2v2H9v-2zm4-3h2v2h-2v-2zm0 3h2v2h-2v-2z" />
                  </svg>
                  <span>{t("filter.breakdown.title", "Price Breakdown")}</span>
                </div>
                <ul className="FilterService-breakdownList">
                  {breakdownRows.map((row, idx) => (
                    <li key={idx} className="FilterService-breakdownRow">
                      <span className="FilterService-breakdownLabel">
                        {row.label}
                      </span>
                      <span className="FilterService-breakdownRight">
                        {row.calc && (
                          <span className="FilterService-breakdownCalc">
                            {row.calc}
                          </span>
                        )}
                        <span className="FilterService-breakdownTotal">
                          {row.total}
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            
            {/* Price Display */}
            <div className="FilterService-priceDisplay">
              <span>
                {t("filter.form.price_display", { price: calculatePrice() })}
              </span>
              {/* <small>{t("filter.form.price_note")}</small> */}
            </div>

            {/* Pricing note banner */}
            <div className="FilterService-priceNote" role="note" aria-live="polite">
              <div className="FilterService-priceNote-icon" aria-hidden="true">
                {/* small star icon (inline SVG) */}
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                </svg>
              </div>
              <div className="FilterService-priceNote-content">
                <div className="FilterService-priceNote-title">
                  {t("filter.price_note.title")}
                </div>
                <p className="FilterService-priceNote-text">
                  <strong>{t("filter.price_note.service_charges_only_label")}</strong>{" "}
                  {t("filter.price_note.body")}
                </p>
              </div>
            </div>


            {/* Booking Details */}
            <div className="FilterService-bookingDetails">
              <div className="FilterService-optionGroup">
                <label htmlFor="date">{t("filter.form.labels.date")}</label>
                <div className="FilterService-dateInputWrapper">
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MMM-yyyy"
                    minDate={new Date()}
                    placeholderText={t("filter.form.labels.date")}
                    className="FilterService-dateInput"
                  />
                  <FaCalendarAlt
                    className="FilterService-dateIcon"
                    onClick={() =>
                      document
                        .querySelector(".FilterService-dateInput")
                        .focus()
                    }
                  />
                </div>
              </div>
              <div className="FilterService-optionGroup">
                <label htmlFor="time">{t("filter.form.labels.time")}</label>
                <select id="time" name="time" required>
                  {generateTimeSlots(selectedDate).map((slot, idx) => (
                    <option key={idx} value={slot}>
                      {slot}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* Remarks */}
            <div className="FilterService-serviceOptions">
              <div className="FilterService-optionGroup FilterService-fullWidth">
                <label htmlFor="remarks">
                  <i className="fas fa-comment-alt"></i>
                  {t("filter.form.labels.remarks")}
                </label>
                <textarea
                  id="remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder={t("filter.form.placeholders.remarks")}
                  className="FilterService-textarea"
                  rows="2"
                />
              </div>
            </div>
            <button type="submit" className="FilterService-actionBtn">
              {rebookState
                ? t("filter.form.rebook_button")
                : t("filter.form.book_button")}
            </button>
          </form>
          {/* Info Box */}
          <div className="FilterService-infoBox">
            <h4>{t("filter.info_box.title")}</h4>
            <p>{t("filter.info_box.description")}</p>
          </div>
          {/* Additional Info Section */}
          <div className="FilterService-additionalInfo">
            <div className="FilterService-sectionCard">
              <h2 className="FilterService-sectionTitle">
                {t("filter.additional_info.how_to_place_order.title")}
              </h2>
              <ol className="FilterService-stepList">
                {getTranslationArray(
                  "filter.additional_info.how_to_place_order.steps"
                ).map((step, idx) => (
                  <li key={idx}>{step}</li>
                ))}
              </ol>
            </div>
            <div className="FilterService-row2col">
              <div className="FilterService-sectionCard FilterService-gradientBg2">
                <h2 className="FilterService-sectionTitle">
                  {t("filter.additional_info.why_choose_HelpNao.title")}
                </h2>
                <p className="FilterService-sectionText">
                  {t("filter.additional_info.why_choose_HelpNao.description")}
                </p>
                <div className="FilterService-featureGrid">
                  {getTranslationArray(
                    "filter.additional_info.why_choose_HelpNao.features"
                  ).map((feature, idx) => (
                    <div key={idx} className="FilterService-featureItem">
                      <i
                        className={`fas fa-${
                          idx === 0
                            ? "balance-scale"
                            : idx === 1
                            ? "user-shield"
                            : idx === 2
                            ? "mobile-alt"
                            : "headset"
                        } FilterService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="FilterService-sectionCard FilterService-gradientBg">
                <h2 className="FilterService-sectionTitle">
                  {t("filter.additional_info.key_features.title")}
                </h2>
                <div className="FilterService-featureGrid">
                  {getTranslationArray(
                    "filter.additional_info.key_features.features"
                  ).map((feature, idx) => (
                    <div key={idx} className="FilterService-featureItem">
                      <i
                        className={`fas fa-${
                          idx === 0
                            ? "clock"
                            : idx === 1
                            ? "shield-alt"
                            : idx === 2
                            ? "check-circle"
                            : idx === 3
                            ? "shield-alt"
                            : "credit-card"
                        } FilterService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="FilterService-sectionCard">
              <h2 className="FilterService-sectionTitle">
                {t("filter.additional_info.service_details.title")}
              </h2>
              <div className="FilterService-serviceGrid">
                {getTranslationArray(
                  "filter.additional_info.service_details.items"
                ).map((item, idx) => (
                  <div key={idx} className="FilterService-serviceItem">
                    <i
                      className={`fas fa-${
                        idx === 0 ? "filter" : "tools"
                      } FilterService-serviceIcon`}
                      aria-hidden="true"
                    ></i>
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="FilterService-sectionCard FilterService-gradientBg3">
              <h2 className="FilterService-sectionTitle">
                {t("filter.additional_info.order_tracking.title")}
              </h2>
              <div className="FilterService-orderTrackIcon">
                <i className="fas fa-file-alt" aria-hidden="true"></i>
              </div>
              <p className="FilterService-sectionText FilterService-centerText">
                {t("filter.additional_info.order_tracking.description")}
              </p>
            </div>
          </div>
        </div>
        {/* Modals */}
        {showOrderForm && (
          <FilterOrderForm
            onClose={() => setShowOrderForm(false)}
            onSubmit={handleOrderSubmit}
            formData={formData}
            user={user}
            previousServitorName={prevServitorName}
          />
        )}
        {showLoginPrompt && (
          <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
        )}
      </div>
      {/* Feedback Section */}
      {ratingData.reviewCount > 0 && (
      <div className="FilterService-feedback-section">
        <FeedbackPage serviceType="Filter" />
      </div>
      )}
      <Footer />
    </>
  );
};
export default FilterService;